import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAccessible24 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 18,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 8.217v1.595a3.75 3.75 0 1 0 4.938 4.938h1.595A5.25 5.25 0 1 1 4.25 8.217Zm3.455-2.662.108.083 2.465 2.112h2.972v1.5H9.723L7.25 7.13v4.37a.25.25 0 0 0 .193.243l.057.007h4.31l3.69 3.689 1-1 1.06 1.061-2.06 2.06-4.311-4.31H7.5a1.75 1.75 0 0 1-1.744-1.607L5.75 11.5V6.587a1.25 1.25 0 0 1 1.955-1.032ZM7.5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: props.color || "#007FAB"
  })
}));
export default SvgAccessible24;